import { messages as companies } from "./companies/en";
import { messages as co2Database } from "./co2-database/en";
import { messages as esgRatings } from "./esg-ratings/en";
import { messages as sco2pesFinancial } from "./sco2pes-financial/en";
import { messages as esgRiskAnalyses } from "./esg-risk-analyses/en";
import { messages as survey } from "./survey/en";
import { messages as users } from "./users/en";
import { messages as esgSelfAssessment } from "./esg-self-assessment/en";
import { messages as units } from "./units/en";
import { messages as integration } from "./integration/en";
import { messages as distanceCalc } from "./distance-calc/en";
import { messages as news } from "./news/en";
import { messages as sso } from "./sso/en";

export const messages = {
  ...companies,
  ...co2Database,
  ...esgRatings,
  ...esgRiskAnalyses,
  ...sco2pesFinancial,
  ...survey,
  ...users,
  ...esgSelfAssessment,
  ...units,
  ...integration,
  ...distanceCalc,
  ...news,
  ...sso,
};
